export class Image {
  type: string;
  data: any;
}
